
export type CreateNotification201Target = {
  /** @nullable */
  targetId?: number | null;
  /** @nullable */
  targetType?: string | null;
};
